import { CurrentSessionCollector, SurveyEndPageArgs } from '../types';

const setSurveyEndPage = ({
  encryptedSmParam,
  completionUrl,
  redirectType,
  allowMultipleResponses,
  isWhiteLabelDomain,
  isSMDomain,
}: SurveyEndPageArgs): void => {
  switch (redirectType) {
    case 'weblink':
      /**
       * CompletionURL is provided by collectSvc
       * Its set to either MTx.com | SM.com | whitelabel domains by default
       * If the url is different from these values, redirect respondent to the custom URL
       * else redirect to /survey-thanks/ page
       */
      if (!(isWhiteLabelDomain || isSMDomain)) {
        window.location.replace(`${completionUrl}`);
        break;
      }
      window.location.replace(`/survey-thanks/?sm=${encryptedSmParam}`);
      break;

    case 'closeWindow':
      window.close();
      break;

    case 'loop':
      if (allowMultipleResponses) window.location.reload();
      break;
    default:
      window.location.replace(`/survey-thanks/?sm=${encryptedSmParam}`);
  }
};

export const surveyEndPageRedirector = (encryptedSmParam: string, collector?: CurrentSessionCollector): void => {
  const completionUrl = collector?.weblink?.completionUrl || '';
  const redirectType = collector?.weblink?.redirectType ?? '';
  const allowMultipleResponses = collector?.allowMultipleResponses ?? false;
  const isSMDomain = collector?.weblink?.isSMDomain ?? true;
  const isWhiteLabelDomain = collector?.weblink?.isWhiteLabelDomain ?? false;
  const surveyResultsUrl = collector?.surveyResultsUrl;

  // If instantResults URL is available, redirect user to it
  if (surveyResultsUrl) {
    window.location.replace(`${surveyResultsUrl}`);
    return;
  }

  setSurveyEndPage({
    encryptedSmParam,
    completionUrl,
    redirectType,
    allowMultipleResponses,
    isSMDomain,
    isWhiteLabelDomain,
  });
};

export default surveyEndPageRedirector;
